// services
import { getUbiEventsEndpoint } from '@sitegen/common/utils/ubi-services';

// types
import { IEventRequest, IOwnershipRequest, IPlatformEvent } from './event-manager.service';

// constants
import { EVENT_MANAGER_URL } from './event-manager.constants';
import {
    PLATFORM_TYPES,
    PLATFORM_XBOX_ONE,
    PLATFORM_XBOX_SERIES
} from '@sitegen/common/constants/platforms';

export const buildEventManagerGetURL = (envName: string, data: IEventRequest) =>
    `${getUbiEventsEndpoint(envName)}${EVENT_MANAGER_URL.api}${data.code}${EVENT_MANAGER_URL.countryParam}${data.country}`;

export const buildEventManagerPostURL = (envName: string, data: IOwnershipRequest) =>
    `${getUbiEventsEndpoint(envName)}${EVENT_MANAGER_URL.api}${data.eventCode}${EVENT_MANAGER_URL.playersRoute}${data.userId}`;

export const normalizeEventPlatforms = (event: IPlatformEvent): IPlatformEvent => {
    const platformMap = {
        [PLATFORM_XBOX_ONE]: { ...event, platform: PLATFORM_TYPES.XONE },
        [PLATFORM_XBOX_SERIES]: { ...event, platform: PLATFORM_TYPES.XSX }
    };

    return platformMap[event.platform] || event;
};
